import isEmpty from 'lodash/isEmpty';

export const insertBackButton = (data, directoryData) => {
  const localData = data;

  if (!isEmpty(directoryData) && !isEmpty(localData)) {
    const rootBackButton = {
      id: 'root',
      type: 'backButton',
      name: '...',
    };
    const backButton = {
      id: directoryData.parentDirectory,
      type: 'backButton',
      name: '...',
    };

    if (directoryData.parentDirectory === null) {
      localData?.results?.[0]?.name !== '...'
        ? localData.results.unshift(rootBackButton)
        : (localData.results[0] = rootBackButton);
    } else {
      localData?.results?.[0]?.name !== '...'
        ? localData.results.unshift(backButton)
        : (localData.results[0] = backButton);
    }
  }
  return localData;
};
